"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = maxLength;

var _isEmpty = _interopRequireDefault(require("./isEmpty"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function maxLength(max) {
  return function (value) {
    if (!(0, _isEmpty["default"])(value) && "".concat(value).length > max) {
      return {
        message: 'validation.maxLength',
        value: max
      };
    }

    return null;
  };
}